/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import axios from 'axios';
import {
    TextField,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TableSortLabel,
    TableFooter,
    TablePagination,
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';
import { Modal, ModalHeader, ModalBody, Label } from 'reactstrap';
import Grid from "components/Grid/GridContainer";
import Col from "components/Grid/GridItem";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Button2 from "components/CustomButtons/Button.js";
import TSText from "components/Forms/TSText";

const useStyles = makeStyles((theme) => ({
    tableContainer: { width: '99.99%', overflowX: 'auto' },
    tableRow: { '&:nth-of-type(odd)': { backgroundColor: theme.palette.action.hover } },
    tableCell: { padding: '2px' },
}));

const HATeamList = () => {
    const tableText = 'ทีม HA';
    const host = '';
    const classes = useStyles();

    const [dataList, setDataList] = useState([]);
    const [selectedData, setSelectedData] = useState(null);
    const [orderDirection, setOrderDirection] = useState('asc');
    const [orderBy, setOrderBy] = useState('sortOrder');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [isEditing, setIsEditing] = useState(false);
    const [editIndex, setEditIndex] = useState(null);

    const [modalOpen, setModalOpen] = useState(false);
    const [modal, setModal] = useState(false);
    const [icon, setIcon] = useState("far fa-question-circle");

    const [Keyword, setKeyword] = useState('');

    useEffect(() => {
        fetchDataList();
    }, [Keyword]);

    const fetchDataList = async () => {
        try {
            const response = await axios.get(`${host}/api/v1/ha/teams?name=${Keyword}`);
            
            if (response.data.result == 200) {
                setDataList(response.data.data);
                
            } else {
                setDataList([]);
            }
        } catch (error) {
            console.error('Error fetching dataList:', error);
            setDataList([]);
        }
    };

    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && orderDirection === 'asc';
        setOrderDirection(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const sortedData = () => {
        return dataList.sort((a, b) => {
            if (orderDirection === 'asc') {
                return a[orderBy] < b[orderBy] ? -1 : 1;
            }
            return a[orderBy] > b[orderBy] ? -1 : 1;
        });
    };

    const handleChangePage = (event, newPage) => setPage(newPage);
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    //เมื่อปิด Modal
    const handleCloseModal = () => {
        setModalOpen(false);
        setSelectedData(null);

        setIsEditing(false);
        setEditIndex(null);
    };


    const handleAdd = () => {
        setSelectedData({ code: '', name: '', sortOrder: 0 });
        setIsEditing(false);
        setModalOpen(true);
    };

    const handleEdit = (index, item) => {
        setIsEditing(true);
        setSelectedData(item);
        setEditIndex(index);
        setModalOpen(true);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSelectedData({ ...selectedData, [name]: value });
    };

    const handleSaveChanges = async () => {
       
        try {
            if (isEditing) {
                await axios.put(`${host}/api/v1/ha/teams/${selectedData.haTeamKey}`, selectedData);
            } else {
                await axios.post(`${host}/api/v1/ha/teams`, selectedData);
            }
            setModalOpen(false);
            fetchDataList();
        } catch (error) {
            console.error("Error saving data:", error);
        }
        
    };

    return (
        <div>
            <Grid>
                <Col xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="primary">
                            <h4>รายการ{tableText}</h4>
                        </CardHeader>
                        <CardBody>
                            <Grid>
                                <Col xs={12} sm={12} md={12}>
                                    <TSText label="ค้นหา" value={Keyword} onChange={e => setKeyword(e.target.value)} />
                                </Col>
                                <Col xs={12} style={{ textAlign: 'right' }}>
                                    <Button2 color="success" onClick={handleAdd}>
                                        <i className="fa fa-plus"></i> เพิ่ม{tableText}
                                    </Button2>
                                </Col>
                            </Grid>
                            <TableContainer component={Paper} className={classes.tableContainer}>
                                <Table className={classes.table} aria-label="data table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>
                                                <TableSortLabel active={orderBy === 'sortOrder'} direction={orderBy === 'sortOrder' ? orderDirection : 'asc'} onClick={() => handleRequestSort('sortOrder')} >
                                                    ลำดับ
                                                </TableSortLabel>
                                            </TableCell>
                                            <TableCell>
                                                <TableSortLabel
                                                    active={orderBy === 'code'}
                                                    direction={orderBy === 'code' ? orderDirection : 'asc'}
                                                    onClick={() => handleRequestSort('code')}
                                                >
                                                    รหัส{tableText}
                                                </TableSortLabel>
                                            </TableCell>
                                            <TableCell>
                                                <TableSortLabel
                                                    active={orderBy === 'name'}
                                                    direction={orderBy === 'name' ? orderDirection : 'asc'}
                                                    onClick={() => handleRequestSort('name')}
                                                >
                                                    ชื่อ{tableText}
                                                </TableSortLabel>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {//dataList.map((asset, index) => (
                                            sortedData()
                                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                .map((data, index) => (
                                                    <TableRow key={index} className={classes.tableRow}>
                                                        <TableCell className={classes.tableCell}>{data.sortOrder}</TableCell>
                                                        <TableCell className={classes.tableCell}><Button style={{ textDecoration: 'underline' }} onClick={() => handleEdit(index, data)}>{data.code}</Button></TableCell>
                                                        <TableCell className={classes.tableCell}><Button style={{ textDecoration: 'underline' }} onClick={() => handleEdit(index, data)}>{data.name}</Button></TableCell>
                                                        {/*<TableCell className={classes.tableCell} style={{ color: (data.assetStatusKey != null && ArrAssetStatus.find(t => t.value == data.assetStatusKey) != null) ? ArrAssetStatus.find(t => t.value == data.assetStatusKey).color : 'black' }} >{(data.assetStatusKey != null && ArrAssetStatus.find(t => t.value == data.assetStatusKey) != null) ? ArrAssetStatus.find(t => t.value == data.assetStatusKey).label : ''}</TableCell>*/}
                                                    </TableRow>
                                                ))}
                                    </TableBody>
                                    <TableFooter>
                                        <TableRow>
                                            <TablePagination
                                                rowsPerPageOptions={[5, 10, 25]}
                                                count={dataList.length}
                                                rowsPerPage={rowsPerPage}
                                                page={page}
                                                onPageChange={handleChangePage}
                                                onRowsPerPageChange={handleChangeRowsPerPage}
                                            />
                                        </TableRow>
                                    </TableFooter>
                                </Table>
                            </TableContainer>

                            
                        </CardBody>

                        <CardFooter>
                            <Modal isOpen={modalOpen} toggle={handleCloseModal}>
                                <ModalHeader toggle={handleCloseModal}></ModalHeader>
                                <ModalBody>
                                    {selectedData && (
                                        <Card>
                                            {(isEditing) ?
                                                <CardHeader color="primary">

                                                    <h4 className={classes.cardTitleWhite}>{selectedData.name}</h4>
                                                    <p className={classes.cardCategoryWhite}>{selectedData.docNo}</p>

                                                </CardHeader>
                                                :
                                                <CardHeader color="primary">
                                                    <h4 className={classes.cardTitleWhite}>เพิ่ม{tableText}</h4>
                                                    <p className={classes.cardCategoryWhite}></p>
                                                </CardHeader>
                                            }
                                            <CardBody>
                                                <Grid>


                                                    <Col xs={12}><TSText name="code" label="รหัส" value={selectedData.code} onChange={handleInputChange} /></Col>
                                                    <Col xs={12}><TSText name="name" label="ชื่อทีม" value={selectedData.name} onChange={handleInputChange} /></Col>
                                                    <Col xs={12}><TSText name="sortOrder" label="ลำดับ" value={selectedData.sortOrder} onChange={handleInputChange} /></Col>
                                            

                                                    <Col xs={12} sm={12} md={12} style={{ marginTop: '20px' }}>
                                                        <Label>ผู้บันทึก: {selectedData.creatorCode} {selectedData.createDatetime}</Label>
                                                    </Col>
                                                    <Col xs={12} sm={12} md={12}>
                                                        <Label>แก้ไขล่าสุด: {selectedData.lastEditerCode} {selectedData.lastEditDatetime}</Label>
                                                    </Col>

                                                </Grid>

                                            </CardBody>
                                            <CardFooter>

                                            </CardFooter>
                                        </Card>
                                    )}
                                </ModalBody>
                                <div className="modal-footer">
                                    <Button2
                                        color="info"
                                        type="button"
                                        onClick={handleSaveChanges}
                                        style={{ marginRight: '50px' }}
                                    >
                                        <h4>บันทึก</h4>
                                    </Button2>

                                    <Button2
                                        color="danger"
                                        type="button"
                                        onClick={handleCloseModal}
                                    >
                                        <h4>ยกเลิก</h4>
                                    </Button2>

                                </div>
                            </Modal>


                            {/* Confirm */}
                            <Modal toggle={() => setModal(false)} isOpen={modal}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className={icon}
                                            style={{ color: "blue", fontSize: "2em" }}
                                        ></i>
                                    </div>
                                </div>
                                <ModalBody>
                                    <p
                                        style={{
                                            textAlign: "center", fontSize: "1.8em"
                                        }}
                                    >
                                        {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                                            ? "ยืนยันการบันทึกข้อมูล"
                                            : "กำลังตรวจสอบข้อมูล"}
                                    </p>
                                    <p> </p>
                                </ModalBody>
                                <div className="modal-footer">

                                    <Button
                                        color="success"
                                        type="button"
                                        //onClick={handleConfirm}
                                        disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                    >
                                        <i className={"fa fa-thumbs-up"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
                                        <h4>ยืนยัน</h4>
                                    </Button>

                                    <Button
                                        color="danger"
                                        type="button"
                                        onClick={() => { setIcon("far fa-question-circle"); setModal(false); }}
                                    >
                                        <i className={"fa fa-thumbs-down"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
                                        <h4>ยกเลิก</h4>
                                    </Button>


                                </div>
                            </Modal>

                        </CardFooter>
                    </Card>
                </Col>
            </Grid>
        </div>
    );
};

export default HATeamList;
